"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FarmYETI = void 0;
/**
 * Farm YETI.
 *
 * @public
 */
class FarmYETI {
    /** @internal */
    constructor(yetiTokenBalance, earnedYETI, totalYETIStaked) {
        this.yetiTokenBalance = yetiTokenBalance;
        this.earnedYETI = earnedYETI;
        this.totalYETIStaked = totalYETIStaked;
    }
    equals(that) {
        return (this.yetiTokenBalance.eq(that.yetiTokenBalance) &&
            this.earnedYETI.eq(that.earnedYETI) &&
            this.totalYETIStaked.eq(that.totalYETIStaked));
    }
}
exports.FarmYETI = FarmYETI;
//# sourceMappingURL=FarmYETI.js.map